/**
 * @title Jumppad: out-recharge-form
 * @description 供应商端充值发起表单 — 精简表单（角色/入口/isExternal 已在组件内固定），开发期自测
 * @category Jumppad
 * @author auto-mpc
 * @date 2026-07-31
 */
import React, { useState } from 'react';
import { Button, InputNumber, Radio, Space, Card, Form } from '@bedrock/components';
import OutRechargeForm from '../../index';

export default function JumppadOutRechargeForm() {
  const [visible, setVisible] = useState(false);
  const [l2DemandId, setL2DemandId] = useState(1);
  const [overseas, setOverseas] = useState(false);

  return (
    <Card title="供应商端充值发起页自测" className="m-4">
      <Space direction="vertical" size={12} className="w-full">
        <Form layout="inline">
          <Form.Item label="二级单ID" required>
            <InputNumber
              value={l2DemandId}
              onChange={(v) => setL2DemandId(Number(v) || 0)}
            />
          </Form.Item>
          <Form.Item label="国内/海外" required>
            <Radio.Group
              value={overseas}
              onChange={(e) => setOverseas(e.target.value)}
            >
              <Radio value={false}>国内</Radio>
              <Radio value={true}>海外</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        <Button type="primary" onClick={() => setVisible(true)}>
          打开发起页
        </Button>
      </Space>
      <OutRechargeForm
        visible={visible}
        onClose={() => setVisible(false)}
        onOk={() => setVisible(false)}
        l2_demand_id={l2DemandId}
        overseas={overseas}
      />
    </Card>
  );
}
